import { Typography } from 'antd';
import Page from 'components/page';
import React from 'react';

const WelcomePage = () => {
  return (
    <Page title="Bienvenido a Prepaga.">
      <Typography.Title>Lo sentimos,</Typography.Title>
      <Typography.Text>
        {' '}
        Si estás viendo esta pantalla, y ningun icono en el menu de la izquierda, quiere decir que no tenes permisos
        asignados, ponete en contacto con el administrador de tu Backoffice para que te los asigne según tu actividad.{' '}
      </Typography.Text>
    </Page>
  );
};

export default WelcomePage;
